import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize GTM
TagManager.initialize({ gtmId: 'GTM-PHH2KT' });

if (process.env.REACT_APP_WIDGET_MODE === 'true') {
  // ✅ Widget Mode (react-app-rewired build)
  // console.log(" window.initialPath", window.initialPath);
  (function () {
    const container = document.getElementById('ldc-booking-engine');
    const ldcConfig = window.ldcConfig || {};
    const { initialPath = "/", productCategoryId, resheduleKey,stateCode,authCode,productId,clinicId } = ldcConfig;

    if (!container) {
      console.error(":x: MyReactWidget: <div id='ldc-booking-engine'> not found!");
    } else {
      const root = ReactDOM.createRoot(container);
      root.render(
        <React.StrictMode>
          <App initialPath={initialPath} productCategoryId={productCategoryId} resheduleKey={resheduleKey} stateCode={stateCode} authCode={authCode} productId={productId} clinicId={clinicId}/>
        </React.StrictMode>
      );
      // console.log(":white_check_mark: LDC Booking Engine rendered automatically");
    }
  })();
} else {
  // ✅ Normal CRA Mode (npm start / npm run build)
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
